'use client';

import { useState, useEffect } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  Bars2Icon,
  BriefcaseIcon,
  LightBulbIcon,


} from '@heroicons/react/20/solid';
import { BookOpenIcon, DocumentChartBarIcon, StarIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import ActivityFeed from '../manager/activitybar';
import MeetingAlert from '../manager/meetingalert';
import ShiftHome from '../manager/shifthome';
import MeetingsCalendar from '../manager/meetingscalendar';
import Stats from '../manager/stats';
import Online from '../manager/online';
import TaskManager from '../manager/taskmanager';
import { AcademicCapIcon } from '@heroicons/react/20/solid';
import { FolderIcon } from '@heroicons/react/24/outline';
import ManagementHome from '../manager/managementhome';
import WeatherData from '../manager/weatherdata';
import AIAssistant from '../manager/aiassistant';
import BackToWorkAlert from '../manager/backtoworkalert';
import NewsHome from '../manager/newshome';
import TaskCalenderToday from './taskcalendarstaff';
import ChatDashboard from '../manager/ChatDashboard';
import MessageAlert from '../manager/messagealert';
import ShiftsAlert from '../manager/shiftsstartalert';
import WorkCoach from '../manager/workcoach';



import { ChatBubbleBottomCenterIcon, PowerIcon, ChartBarSquareIcon, UserPlusIcon } from '@heroicons/react/16/solid';
import StaffHome from './staffhome';
import { AuthContext } from '../AuthContext';
import { useContext } from 'react';

const navigation = [
  { name: 'Dashboard', href: '/staffdash', icon: HomeIcon, current: true },
  { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false },
    { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false },
  { name: 'Business Structure', href: '/organizationaltree', icon: BriefcaseIcon, current: false },
  { name: 'Sales / Project CRM', href: '/customercrm', icon: UserGroupIcon, current: false },
  { name: 'My Projects', href: '/staff-project', icon: ChartBarSquareIcon, current: false },
  {name: 'Admin Tasks', href: '/admin-tasks', icon: DocumentChartBarIcon, current: false},
  {name: 'Brainstorm', href: '/brainstorm', icon: StarIcon, current: false },
  
  {name: 'Back to Work', href: '/back-to-work', icon: ArrowPathRoundedSquareIcon, current: false},  { name: 'Brainstorm', href: '/brainstorm', icon: LightBulbIcon, current: false },  { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false },
  { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false },
];


const tabs = [
  { name: 'Home', component: <StaffHome />, icon: BookOpenIcon },

  { name: 'My Tasks', component: <TaskCalenderToday />, icon: UserIcon },
  {name: 'To-Do', component: <WorkCoach />, icon: UserIcon },
  { name: 'Meetings', component: <MeetingsCalendar />, icon: CalendarDaysIcon },
  { name: 'News Feed', component: <NewsHome />, icon: DocumentDuplicateIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(tabs[1].name); // Default to the first tab
  const [AI, SetAI] = useState(false);
  const [mobileActivityOpen, setMobileActivityOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const renderComponent = () => {
    const currentTabData = tabs.find((tab) => tab.name === currentTab);
    return currentTabData ? currentTabData.component : null;
  };

  const navigate = useNavigate();
  const user = useContext(AuthContext);
  const canAccessAvenor = ['admin', 'manager', 'staff'].includes(String(user?.access || '').toLowerCase());

  

  const handleCloseAIAssistant = () => {
    SetAI(false);
  };

  // Check if the device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check initially
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Handler to close mobile activity feed when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const activityFeedContainer = document.getElementById('mobile-activity-feed');
      const activityToggleButton = document.getElementById('activity-toggle-button');
      
      if (
        mobileActivityOpen &&
        activityFeedContainer && 
        !activityFeedContainer.contains(event.target) &&
        activityToggleButton &&
        !activityToggleButton.contains(event.target)
      ) {
        setMobileActivityOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileActivityOpen]);

  return (
    <>
      <div data-component="staff-dashboard">
        
      

        <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-white transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                  <button
                    type="button"
                    data-component="staff-dashboard-sidebar"
                    data-bucket="task-management"
                    data-feature="close"
                    onClick={() => setSidebarOpen(false)}
                    className="-m-2.5 p-2.5"
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                  </button>
                </div>
              </TransitionChild>

              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gradient-to-b from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% px-6 pb-2 ring-1 ring-white/10">
                <div className="flex h-16 shrink-0 items-center">
                  <img
                    alt="Your Company"
                    src="/2.png"
                    className="h-8 w-auto rounded-full bg-gray-900"
                  />
                </div>
                {canAccessAvenor && (
                  <Link
                    to="/avenor"
                    className="mb-1 flex items-center justify-center rounded-lg bg-white/20 px-2 py-1 text-xs font-bold text-white hover:bg-white/30 transition-colors"
                  >
                    <img src="/avenor.png" alt="Avenor" className="h-6" />
                  </Link>
                )}
                <nav className="flex flex-1 flex-col">
                  <ul role="list" className="-mx-2 flex-1 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          data-component="staff-dashboard-nav"
                          data-bucket="task-management"
                          data-feature={item.name.replace(/\s+/g, '-').toLowerCase()}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? 'bg-blue-700 text-white'
                              : 'text-white hover:bg-blue-700 hover:text-white',
                            'group relative flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                          )}
                        >
                          <item.icon aria-hidden="true" className="size-6 shrink-0" />
                          {/* Tooltip */}
                            {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:block lg:w-20 lg:overflow-y-auto lg:bg-gradient-to-b from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% lg:pb-4">
          <div className="flex h-16 shrink-0 items-center justify-center">
            <img
              alt="Your Company"
              src="/2.png"
              className="h-8 rounded-full bg-gray-900 w-auto"
            />
          </div>
          <div className="flex justify-center">
            {canAccessAvenor && (
              <Link
                to="/avenor"
                className="rounded-lg bg-white/20 px-2 py-1 text-xs font-bold text-white hover:bg-white/30 transition-colors"
              >
                <img src="/avenor.png" alt="Avenor" className="h-6" />
              </Link>
            )}
          </div>
          <nav className="mt-8">
            <ul role="list" className="flex flex-col items-center space-y-1">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    data-component="staff-dashboard-nav"
                    data-bucket="task-management"
                    data-feature={item.name.replace(/\s+/g, '-').toLowerCase()}
                    to={item.href}
                    className={classNames(
                      item.current
                        ? 'bg-white text-blue-700'
                        : 'text-white hover:bg-blue-700 hover:text-white',
                      'group relative flex items-center gap-x-3 rounded-md p-3 text-sm font-semibold',
                    )}
                  >
                    <item.icon aria-hidden="true" className="h-6 w-6 shrink-0" />
                    {/* Tooltip */}
                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 scale-0 rounded-md bg-gray-700 px-3 py-1 text-xs text-white shadow-lg transition-all duration-150 group-hover:scale-100">
  {item.name}
</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-gradient-to-l from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% px-4 py-4 shadow-sm sm:px-6 lg:hidden">
          <button
            type="button"
            data-component="staff-dashboard-sidebar"
            data-bucket="task-management"
            data-feature="open"
            onClick={() => setSidebarOpen(true)}
            className="-m-2.5 p-2.5 text-white lg:hidden"
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
          <div className="flex-1 text-md font-semibold text-white">Dashboard</div>
          <button 
            id="activity-toggle-button"
            data-component="staff-dashboard-activity"
            data-bucket="task-management"
            data-feature="toggle"
            onClick={() => setMobileActivityOpen(!mobileActivityOpen)}
            className="text-white mr-3 relative"
            aria-label="Toggle activity menu"
          >
            <ChartBarIcon className="h-6 w-6" />
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
            </span>
          </button>
          <a href="#">
            <span className="sr-only">Your profile</span>
            <img
              alt=""
              src="/2.png"
              className="size-10 rounded-full bg-gray-800"
            />
          </a>
        </div>

        {/* Mobile Full Screen Activity Panel */}
        <AnimatePresence>
          {mobileActivityOpen && (
            <motion.div 
              id="mobile-activity-feed"
              initial={{ opacity: 0, x: '100%' }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: '100%' }}
              transition={{ duration: 0.3 }}
              className="lg:hidden fixed inset-0 z-50 bg-white overflow-y-auto max-h-full"
              style={{ overscrollBehavior: 'contain' }}
            >
              <div className="flex flex-col h-full">
                <div className="sticky top-0 bg-white z-10 p-4 border-b border-gray-200">
                  <div className="flex justify-between items-center">
                    <h3 className="font-semibold text-gray-800 flex items-center">
                      <ChartBarIcon className="h-5 w-5 mr-2 text-blue-500" />
                      Activity & Weather
                    </h3>
                    <button 
                      data-component="staff-dashboard-activity"
                      data-bucket="task-management"
                      data-feature="close"
                      onClick={() => setMobileActivityOpen(false)}
                      className="text-gray-500 hover:text-gray-700 bg-gray-100 rounded-full p-1"
                    >
                      <XMarkIcon className="h-5 w-5" />
                    </button>
                  </div>
                </div>
                <div className="flex-1 overflow-y-auto p-4">
                  <WeatherData />
                
                  <div className="mt-4">
                    <button
                      type="button"
                      data-component="staff-dashboard-activity"
                      data-bucket="task-management"
                      data-feature="open-support"
                      onClick={() => {
                        SetAI(true);
                        setMobileActivityOpen(false);
                      }}
                      className="w-full inline-flex items-center justify-center gap-x-1.5 rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >            
                      <LightBulbIcon className="h-6 w-6" />
                      Support
                    </button>
                  </div>
                  {/* Activity Feed */}
                  <div className="mt-4 pb-20"> {/* Added padding at the bottom */}
                    <ActivityFeed mobileView={true} />
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <main className="lg:pl-20">

<div className="xl:pl-96">
<div>
  <div className="sm:hidden mt-4">
    <div dir="rtl" className="overflow-x-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
      <div dir="ltr" className="mx-auto flex w-max min-w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-50 via-white to-purple-50 p-1 shadow-lg">
        {tabs.map((tab) => {
          const MobileTabIcon = tab.icon;
          const active = tab.name === currentTab;

          return (
            <button
              key={tab.name}
              type="button"
              onClick={() => setCurrentTab(tab.name)}
              aria-label={tab.name}
              title={tab.name}
              data-component="staff-dashboard-tab"
              data-bucket="task-management"
              data-feature={tab.name.replace(/\s+/g, '-').toLowerCase()}
              className={`h-10 w-10 inline-flex items-center justify-center rounded-lg border transition-all ${
                active
                  ? 'bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 border-white/20 text-white shadow-lg shadow-indigo-950/40'
                  : 'bg-white/60 border-indigo-200/70 text-indigo-900 hover:bg-white/75'
              }`}
            >
              <MobileTabIcon className="h-4 w-4" />
            </button>
          );
        })}
      </div>
    </div>
  </div>
  <div className="hidden sm:block">
    <nav
      aria-label="Tabs"
      className="isolate flex overflow-x-auto flex-nowrap gap-1 rounded-2xl bg-gradient-to-r from-blue-50 via-white to-purple-50 p-1 shadow-lg hide-scrollbar"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {tabs.map((tab) => {
        const DesktopTabIcon = tab.icon;

        return (
          <motion.button
            data-component="staff-dashboard-tab"
            data-bucket="task-management"
            data-feature={tab.name.replace(/\s+/g, '-').toLowerCase()}
            key={tab.name}
            onClick={() => setCurrentTab(tab.name)}
            aria-current={tab.name === currentTab ? 'page' : undefined}
            className={`group relative min-w-[96px] flex-1 overflow-hidden rounded-xl border px-3 py-2 text-center text-xs font-medium transition-all duration-200 md:min-w-[110px] md:text-sm ${
              tab.name === currentTab
                ? 'border-blue-500 bg-blue-100 text-blue-900 shadow'
                : tab.hasUnreadMessages
                ? 'border-blue-300 bg-blue-50 text-blue-700 animate-pulse'
                : 'border-transparent bg-white text-blue-700 hover:bg-blue-700 hover:text-white'
            }`}
            whileTap={{ scale: 0.97 }}
            whileHover={{ scale: 1.04 }}
            animate={
              tab.hasUnreadMessages
                ? {
                    backgroundColor: ['#f0f7ff', '#0023bc', '#f0f7ff'],
                    scale: [1, 1.05, 1],
                  }
                : {}
            }
            transition={{ duration: 1.5, repeat: tab.hasUnreadMessages ? Infinity : 0 }}
          >
            <span className="inline-flex items-center gap-2">
              <DesktopTabIcon className="h-4 w-4" />
              <span>{tab.name}</span>
            </span>
            {tab.hasUnreadMessages && (
              <span className="absolute top-1 right-1 block h-2.5 w-2.5 rounded-full bg-blue-700 shadow-lg" />
            )}
          </motion.button>
        );
      })}
    </nav>
    <style>{`
      .hide-scrollbar::-webkit-scrollbar { display: none; }
      .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    `}</style>
  </div>
</div>
<div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-6">
<AnimatePresence>
{renderComponent() && (
<motion.div
  key={currentTab}
  initial={{ opacity: 0, scale: 0.9 }} // Initial state
  animate={{ opacity: 1, scale: 1 }} // Animate to this state
  exit={{ opacity: 0, scale: 0.9 }} // Exit state
  transition={{ duration: 0.3 }} // Transition duration
>
  {renderComponent()}
</motion.div>
)}
</AnimatePresence>
</div>
</div>

</main>

<aside className="fixed inset-y-0 left-20 hidden w-96 overflow-y-auto border-r border-gray-200 px-4 py-6 sm:px-6 lg:px-8 xl:block">
<WeatherData />

<div className="flex items-center justify-between mb-4">
    <h2 className="text-lg font-semibold text-gray-900">Activity Feed</h2>
     
    
        <button
          type="button"
          data-component="staff-dashboard-support"
          data-bucket="task-management"
          data-feature="open"
          onClick={() => SetAI(true)}
          className="inline-flex ml-10 items-center gap-x-1.5 rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >            
              <LightBulbIcon className="h-6 w-6" />
Support            </button>
</div>
          
<ActivityFeed   />
</aside>
</div>
{AI && (
          <div className={`fixed z-50 ${isMobile ? 'inset-0 bg-white overflow-y-auto' : 'bottom-0 right-0 p-4'}`}>
            <AIAssistant AiAssistant={AI} onClose={handleCloseAIAssistant} isMobile={isMobile} />
          </div>
        )}
<div className="fixed top-4 right-4 z-50">
<MeetingAlert />
</div>

<div className="fixed top-4 right-4 z-50">
  <MessageAlert />
</div>
<div className="fixed top-4 right-4 z-50">
  <ShiftsAlert />
</div>
    </>
  );
}
